import classnames from 'classnames'
import { m, LazyMotion, domAnimation, useAnimation, Variants } from 'framer-motion'
import { forwardRef, useCallback } from 'react'

import { BRANDS_INFO } from '../../../utils/constants'
import { DiagonalLineLarge, DiagonalLineSmall } from '../../../assets/icons'

import styles from './styles.module.scss'

const CONTENT_VARIANTS: Variants = {
  start: { y: '50%', opacity: 0 },
  end: {
    y: '0%',
    opacity: 1,
    transition: { type: 'spring', bounce: 0 },
  },
}

const BRANDS_LIST = [
  { ...BRANDS_INFO['loadsmart'], className: 'loadsmart' },
  { ...BRANDS_INFO['benepass'], className: 'benepass' },
  { ...BRANDS_INFO['shareThis'], className: 'sharethis' },
  { ...BRANDS_INFO['gbe'], className: 'gbe' },
  { ...BRANDS_INFO['hapana'], className: 'hapana' },
  { ...BRANDS_INFO['highnote'], className: 'highnote' },
  { ...BRANDS_INFO['pythonic'], className: 'pythonic' },
  { ...BRANDS_INFO['scholarsOfFinance'], className: 'scholarsoffinance' },
  { ...BRANDS_INFO['dvora'], className: 'dvora' },
  { ...BRANDS_INFO['swingDev'], className: 'swingdev' },
  { ...BRANDS_INFO['vitalTrace'], className: 'vitaltrace' },
  { ...BRANDS_INFO['soundOff'], className: 'soundoff' },
]

export const TrustedBySection = forwardRef<HTMLElement>((_, ref) => {
  const contentControl = useAnimation()
  const onViewportEnter = useCallback(async () => {
    contentControl.start('end')
  }, [contentControl])

  return (
    <section className={styles['container']} ref={ref}>
      <div className={styles['content']}>
        <h2 className={styles['title']}>
          Trusted <span className={styles['by']}>by</span>
        </h2>
        <LazyMotion features={domAnimation} strict>
          <m.div
            variants={CONTENT_VARIANTS}
            initial="start"
            animate={contentControl}
            viewport={{ once: true, amount: 0.2 }}
            onViewportEnter={onViewportEnter}
            className={styles['logos-container']}
          >
            {BRANDS_LIST.map(brand => (
              <a
                className={classnames(styles['link'], styles[brand.className])}
                href={brand.href}
                target="_blank"
                rel="noreferrer"
                aria-label={`Access ${brand.id} homepage`}
              >
                <brand.icon className={styles['icon']} />
              </a>
            ))}
            <DiagonalLineLarge className={classnames(styles['diagonal-icon'], styles['diagonal-two'])} />
            <DiagonalLineLarge className={classnames(styles['diagonal-icon'], styles['diagonal-one'])} />
            <div className={classnames(styles['horizontal-line'], styles['horizontal-line-one'])} />
            <div className={classnames(styles['horizontal-line'], styles['horizontal-line-two'])} />
            <div className={classnames(styles['horizontal-line'], styles['horizontal-line-three'])} />
            <div className={classnames(styles['horizontal-line'], styles['horizontal-line-four'])} />
            <div className={classnames(styles['horizontal-line'], styles['horizontal-line-five'])} />
            <DiagonalLineSmall className={styles['diagonal-line-small-icon']} />
          </m.div>
        </LazyMotion>
      </div>
    </section>
  )
})

export default TrustedBySection
